import reducer from './store/reducer'

export { DevMode } from './views'

export const apiToInstall = {
  account: process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_DEV_API_ROOT
    : process.env.REACT_APP_PROD_API_ROOT
}

export const storeToInstall = {
  account: reducer
}
